import { h } from 'preact';
import { useMemo } from 'preact/hooks';
import Image from 'utils/image';

const truncateString = (str, num) =>
  str.length > num ? `${str.slice(0, num)}...` : str;

const BlogArticle = ({article, fixedAspectRatio, imagePlaceholder,  blogUrl = ''}) => {
  const excerpt = useMemo(() =>
      article.excerpt || truncateString(article.content, 80),
    [article]);
  
  return (
    <div>
      <a
        href={`${blogUrl}/${article.handle}`}
        className={`block relative mb-4 ${fixedAspectRatio ? 'pb-[31.7%] md:pb-[28.7%]' : 'pb-[75.25%] md:pb-[85.5%]'}`}
      >
        {article.image ? (
          <Image
            {...article.image}
            srcWidths={{ sm: 300, md: 400 }}
            classes='absolute inset-0 object-cover h-full w-full'
          />
        ) : (
          <div
            className='[&_svg]:absolute [&_svg]:inset-0 [&_svg]:object-cover [&_svg]:h-full [&_svg]:w-full'
            dangerouslySetInnerHTML={{__html: imagePlaceholder}}
          ></div>
        )}
      </a>
      <a href={`${blogUrl}/${article.handle}`} className='hover:underline'>
        <h3 className="text-body-2 font-medium mb-4">{article.cardTitle?.value ?? article.title}</h3>
      </a>
      <a href={`${blogUrl}/${article.handle}`} className="hover:underline block text-body-light mb-4">
        {excerpt}
      </a>
      <a href={`${blogUrl}/${article.handle}`} className="underline text-body-light hover:no-underline">
        {window.TMW.Strings.blog.readMore}
      </a>
    </div>
  );
}

export default BlogArticle;
